module.exports = "img/flags/CY.a52dad2.png";